import { GET_USER_TYPE_REUQEST, GET_USER_TYPE_SUCCESS, GET_USER_TYPE_ERROR } from "../actions/types"
export default function (state = null, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_USER_TYPE_REUQEST:
            return {
                loading: true,
            };
        case GET_USER_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_USER_TYPE_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}